export enum GameHypnoType {
  off = 'off',
  joi = 'joi',
  breeding = 'breeding',
  maledom = 'maledom',
  femdom = 'femdom',
  custom = 'custom',
}

export const GameHypnoLabels: Record<GameHypnoType, string> = {
  off: 'Off',
  joi: 'JOI',
  breeding: 'Breeding',
  maledom: 'Maledom Pet',
  femdom: 'Femdom Pet',
  custom: 'Custom',
};

export const GameHypnoDescriptions: Record<GameHypnoType, string> = {
  off: 'Turn off the hypnosis all-together',
  joi: 'Focus on masturbation encouragement',
  breeding: 'Focus on breeding and primal urge',
  maledom: "Good pets get master's treats",
  femdom: "Good pets get mistress' treats",
  custom: "Create your own on-screen text",
};

export const HypnoPhrases: Record<GameHypnoType, string[]> = {
  off: [],
  joi: [
    '$part',
    'stroke',
    'precum',
    'horny',
    'need',
    'instinct',
    "can't stop",
    'ooze',
    'leak',
    '$stroke',
    'hard',
    '$stroke',
    'jack off',
    'give in',
    'obey',
    'pre',
    'must',
    'masturbate',
    'goon',
    '$part',
    'everyday',
  ],
  breeding: [
    'breed',
    'seed',
    'deep',
    'must',
    'instinct',
    'breed',
    'instinct',
    'fuck',
    'shoot',
    'ooze',
    'moan',
    'give in',
    'fill',
    'sperm',
    'breed',
    'sperm',
    'give in',
  ],
  maledom: [
    'good $player',
    'hump',
    'listen',
    'stare',
    'obey',
    '$stroke for master',
    '$stroke for master',
    'obey',
    'master',
    'owner',
    'obey',
    'give in',
    'obey master',
    'good $player',
    'good $player',
    'good $player',
    'animal',
    'only',
    'master',
    'give master',
    'not your $part',
    'not your $part',
    'not your $part',
    'not your cum',
    "master's $part",
    "master's $part",
    "master's $part",
    "master's cum",
  ],
  femdom: [
    'good $player',
    'hump',
    'obey',
    'listen',
    'stare',
    'obey',
    '$stroke for mistress',
    '$stroke for mistress',
    'mistress',
    'owner',
    'obey',
    'give in',
    'obey mistress',
    'good $player',
    'good $player',
    'good $player',
    'animal',
    'only',
    'mistress',
    'give mistress',
    'not your $part',
    'not your $part',
    'not your $part',
    'not your cum',
    "mistress' $part",
    "mistress' $part",
    "mistress' $part",
    "mistress' cum",
  ],
  custom: [],
};
